import Map from "@rio-cloud/rio-uikit/Map";
import Marker from "@rio-cloud/rio-uikit/Marker";
import SingleMapMarker from "@rio-cloud/rio-uikit/SingleMapMarker";

interface SimpleMapProps {
  lat: number;
  lng: number;
  zoom?: number;
  height?: number;
}

const API_KEY = process.env.REACT_APP_RIO_MAP_KEY || "";

const SimpleMap = ({ lat, lng, zoom = 14, height = 150 }: SimpleMapProps) => {
  const center = { lat, lng };

  return (
    <div style={{ height, width: "100%", borderRadius: 4, overflow: "hidden" }}>
      <Map credentials={{ apikey: API_KEY }} language="pt-BR" center={center} zoom={zoom} hideMapSettings>
        {() => (
          <Marker
            position={center}
            icon={
              <SingleMapMarker
                markerColor="bg-map-marker-asset"
                iconNames={["rioglyph rioglyph-poi"]}
                anchorSize="md"
                style={{ ["--color-map-marker-asset" as never]: "var(--brand-primary)" }}
              />
            }
          />
        )}
      </Map>
    </div>
  );
};

export default SimpleMap;
